export const emeaSummaryConstants= {
    EMEA_SUMMARY_LOADING: 'EMEA_SUMMARY_LOADING',
    EMEA_SUMMARY_SUCCESS: 'EMEA_SUMMARY_SUCCESS',
    EMEA_SUMMARY_FAILED: 'EMEA_SUMMARY_FAILED'
}